import { create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  GetBackendSegmentEventRequestType,
  GetCreateFreeOrderRequestType,
  GetCreateFreeOrderResponseType,
  GetCreatePaymentOrderRequestType,
  GetCreatePaymentOrderResponseType,
  GetOrderStatusRequestType,
  GetOrderStatusResponseType,
  GetOrderUpdateUserExtraInfoRequestType,
  GetPaymentServicesResponseType,
  GetProductDetailsRequestType,
  GetProductDetailsResponseType,
  GetReferralCodesResponseType,
  GetUserOrderReferralDiscountRequestType,
  GetUserOrderReferralDiscountResponseType,
  GetUserOrdersDetailsResponseType
} from './types';

import { PaymentServiceTypes } from '.';

class PaymentServiceAPI implements PaymentServiceTypes {
  api!: Record<string, any>;
  networkCallWithApisauce: any;

  constructor(networkCallWithApisauce) {
    this.api = create({
      baseURL: `${Config['PAYMENT_URL']}`
    });
    this.networkCallWithApisauce = networkCallWithApisauce;
  }

  getSelectedProductInfo({
    productCode,
    requestObject
  }: {
    productCode: string;
    requestObject: GetProductDetailsRequestType;
  }): Promise<GetProductDetailsResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      `product_details/${productCode}/v1/`,
      requestObject,
      apiMethods.post
    );
  }

  getPaymentGateways(
    productCode: string
  ): Promise<GetPaymentServicesResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      `products/${productCode}/payment_services/v1/`,
      {},
      apiMethods.get
    );
  }

  createPaymentOrderAndGetDetails(
    requestObject: GetCreatePaymentOrderRequestType
  ): Promise<GetCreatePaymentOrderResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      'razorpay/order/create/v1/',
      requestObject,
      apiMethods.post
    );
  }

  createZeroAmountOrder(
    requestObject: GetCreateFreeOrderRequestType
  ): Promise<GetCreateFreeOrderResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      'orders/create/free/v1/',
      requestObject,
      apiMethods.post
    );
  }

  checkReferralCode(
    requestObject: GetUserOrderReferralDiscountRequestType
  ): Promise<GetUserOrderReferralDiscountResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      'user/order/referral_discount/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getOrderStatus(
    requestObject: GetOrderStatusRequestType
  ): Promise<GetOrderStatusResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      'order/status/v2/',
      requestObject,
      apiMethods.post
    );
  }

  segmentEvent(requestObject: GetBackendSegmentEventRequestType): Promise<{}> {
    return this.networkCallWithApisauce(
      this.api,
      'event/segment/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getReferralCodes({
    productCode
  }: {
    productCode: string;
  }): Promise<GetReferralCodesResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      `products/${productCode}/referral_codes/v1/`,
      {},
      apiMethods.get
    );
  }

  updateUserExtraInfo(
    requestObject: GetOrderUpdateUserExtraInfoRequestType
  ): Promise<{}> {
    return this.networkCallWithApisauce(
      this.api,
      '/order/update/user_extra_info/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getUserOrdersDetails(): Promise<GetUserOrdersDetailsResponseType> {
    return this.networkCallWithApisauce(
      this.api,
      'user/orders/v1/',
      {},
      apiMethods.get
    );
  }
}
export default PaymentServiceAPI;
